import { Boundaries } from "@planzone/core";
import { chatJob } from "@planzone/dto";
import { events } from "@planzone/events";
import { createStateReducer } from "../../utils/createStateReducer";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";

const initialState: State = {
  request: {
    isPending: false,
    isSuccessful: false,
    isFailure: false,
  },
  job: chatJob,
};

function handleRequest(state: State): State {
  return {
    ...state,
    request: { ...initialState.request, isPending: true },
  };
}

function handleSuccess(
  state: State,
  job: Boundaries["submitMessage"]["success"],
): State {
  return {
    ...state,
    request: { ...initialState.request, isSuccessful: true },
    job,
  };
}

function handleFailure(state: State): State {
  return {
    ...state,
    request: { ...initialState.request, isFailure: true },
  };
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.submitMessageRequested]: handleRequest,
    [events.submitMessageSucceeded]: handleSuccess,
    [events.submitMessageFailed]: handleFailure,
  }),
  [events.changePlanzoneSucceeded],
);

function createSelector(getState: () => State): Selector {
  return {
    isSubmitMessageRequestFailure() {
      return getState().request.isFailure;
    },
    isSubmitMessageRequestPending() {
      return getState().request.isPending;
    },
    isSubmitMessageRequestSuccess() {
      return getState().request.isSuccessful;
    },
    getChatJob() {
      return getState().job;
    },
  };
}

export type { State, Selector };

export { reduceState, initialState, createSelector };
